import { shoppingApi } from 'app/src/services/welfareportal'
import { useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'

type TextKey = 'Title' | 'ID_1' | 'ID_2' | 'ID_3' | 'ID_4' | 'ID_5' | 'ID_6' | 'ID_7'

export function ReminderBalanceDialog(props: { onClose: () => void; showSpendingReminder: boolean }) {
  const context = useWebAppContext()
  const credit = shoppingApi.useCreditGet({})
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.BalanceReminderDialog' })
  const balance = credit.data?.creditByServiceCategory?.welfareArt100?.available || 0
  const spendingReminderConfig = context.userInfo.welfareCampaign?.configuration?.spendingReminder

  // Trova il range appropriato per il balance corrente
  const currentRange = spendingReminderConfig?.ranges?.find((range) => balance >= range.from && balance <= range.to)
  const textKey = currentRange?.msgKey as TextKey
  const displayText = t(textKey)

  return (
    credit.isSuccess &&
    currentRange && (
      <Dialog
        onHide={() => {
          props.onClose()
        }}
        visible={props.showSpendingReminder}
        style={{ width: '90vw', maxWidth: '800px' }}
        contentStyle={{ maxHeight: '70vh', overflow: 'auto' }}
        header={t('Title')}
        footer={
          <div>
            <div className='mx-auto mt-6 flex justify-center'>
              <Button
                label={t('ConfirmButtonLabel')}
                rounded
                onClick={() => {
                  props.onClose()
                  sessionStorage.setItem('spendingReminderShown', 'false')
                }}
              />
            </div>
          </div>
        }
      >
        <div dangerouslySetInnerHTML={{ __html: displayText ?? '' }} />
      </Dialog>
    )
  )
}
